import { authHeader, handleResponse } from './helper';
import { apiClinicalUrl } from '../config';

export const initializeSurveyExam = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify({
      admission_patient_exam_id: params.admissionPatientExamId,
      user_id: params.userId
    })
  };

  const url = new URL(`${apiClinicalUrl}/exams/initializeSurveyExam`);
  return await fetch(url, requestOptions).then(handleResponse);
};